import moment from "jalali-moment";
// import { isValidISODateString, isValidDate } from "iso-datestring-validator";
import i18n from "@/libs/i18n/i18n";
export default {
  methods: {
    fromCleaveDateConvert(date, isForeigner = false) {
      let m = moment(date, "jYYYY/jMM/jDD");
      if (
        (!isForeigner &&
          !m.isBefore(moment("1900/01/01", "jYYYY/jMM/jDD"), "year")) ||
        (isForeigner &&
          m.isBefore(moment("1900/01/01", "jYYYY/jMM/jDD"), "year"))
      ) {
        return null;
      }
      if (
        // isValidDate(date, '/') &&
        // && !m.isBefore(moment("1900/01/01", "jYYYY/jMM/jDD"), "year")
        !isForeigner
      ) {
        let newDate = this.toGreg(date);
        return this.toIsoDate(this.toUTC(newDate));
      } else {
        // let newDate = this.toGreg(date);
        return this.toIsoDate(this.toUTC(date));
      }

      //       let m = moment(date, "jYYYY/jM/jD")
      //
      //       let newDate = date;
      //       if (isForeigner){
      //         if (isValidDate(date, '/') && !m.isBefore(moment("1900/01/01", "jYYYY/jMM/jDD"), "year")) {
      //           // let newDate = m._d.year + "/" + m._d.month + "/" + m._d.date + ' ' + m._d.hour + ':' + m._d.minute + ':' + m._d.second;
      //           // if (m.isBefore(moment("1900/01/01", "jYYYY/jMM/jDD"), "year") && !isForeigner) {
      //           //   newDate = this.toGreg(date);
      //           // }
      //           return this.toIsoDate(this.toUTC(newDate));
      //         } else {
      //           return '';
      //         }
      //       }else{
      //         if (m.isBefore(moment("1900/01/01", "jYYYY/jMM/jDD"), "year")) {
      //           newDate = this.toGreg(date);
      //
      //         }
      //
      //         return this.toIsoDate(this.toUTC(newDate));
      //       }
    },
    toCleaveDateConvert(date, isForeigner) {
      if (isForeigner) {
        return moment(date).format("YYYY/MM/DD");
      } else {
        return moment(date).format("jYYYY/jMM/jDD");
      }

      // let m = moment(date, "jYYYY/jM/jD HH:mm");
      // let m = moment(date, "YYYY/M/D")
      // if(isValidISODateString(date)){
      //
      // let newDate = date;
      // if (!isForeigner) {
      //   // newDate = this.dateToPersian(date);
      //     newDate =  moment.from(date, 'fa').format("jYYYY/jMM/jDD");
      // }else{
      //   let m = moment.from(date).format("YYYY-MM-DD");
      //   newDate =  moment.from(date).format("YYYY/MM/DD");
      // }
      // return newDate;
      // }else{
      //     return date
      // }
    },
    sortDates(arrayObjectDates) {
      return arrayObjectDates.sort(function (a, b) {
        let dateA = new Date(a.date),
          dateB = new Date(b.date);
        return dateA - dateB;
      });
    },

    toGreg(value) {
      return moment
        .from(value, "fa", "jYYYY/jMM/jDD HH:mm")
        .locale("en")
        .format("YYYY-MM-DD HH:mm");
    },

    toIsoDate(value, h = 0, m = 0, s = 0, ms = 0) {
      let date = new Date(new Date(value).toString().split("GMT")[0] + " UTC");
      if (date instanceof Date && !isNaN(date)) {
        return date.toISOString();
      } else {
        return "";
      }
    },
    toIsoDateTime(value, h = 0, m = 0, s = 0, ms = 0) {
      let date = new Date(value);
      return date.toISOString();
    },

    toUTC(value) {
      return moment.from(value).format("YYYY-MM-DD HH:mm");
    },

    arrayToUTC(value, hasTime= true) {
      if (value.length) {
        return value.map((val) => {
          if (hasTime) {
            return moment.from(val).format("YYYY-MM-DD HH:mm");
          }else{
            return moment.from(val).format("YYYY-MM-DD");
          }
        });
      } else {
        return null;
      }
    },

    dateToPersian(value) {
      if (value && value.length) {
        return moment.from(value).locale("fa").format("YYYY/MM/DD");
      }
      return "";
    },

    dateToPersianTime(value) {
      if (value && value.length) {
        return moment.from(value).locale("fa").format("HH:mm");
      }
      return "";
    },

    appendCustomTimeToDate(date,time) {
      let newDate= new Date(date.split("T")[0]) ;

      // Set hours
      newDate.setHours(time.split(":")[0]);
      newDate.setMinutes(time.split(":")[1]);
      newDate.setSeconds(0);

      return newDate.toISOString();
    },

    getAge(dateString, returnAsArray = false) {
      if (dateString === undefined || dateString === null) return;
      dateString = dateString.length ? dateString.split("T")[0] : "";
      dateString = dateString.replaceAll("-", "/");
      dateString = moment.from(dateString).format("DD/MM/YYYY");
      let now = new Date();
      let yearNow = now.getYear();
      let monthNow = now.getMonth();
      let dateNow = now.getDate();

      let dob = new Date(
        dateString.substring(6, 10),
        dateString.substring(3, 5) - 1,
        dateString.substring(0, 2)
      );

      let yearDob = dob.getYear();
      let monthDob = dob.getMonth();
      let dateDob = dob.getDate();

      let yearAge = yearNow - yearDob;
      let monthAge = "";
      let dateAge = "";
      if (monthNow >= monthDob) monthAge = monthNow - monthDob;
      else {
        yearAge--;
        monthAge = 12 + monthNow - monthDob;
      }

      if (dateNow >= dateDob) dateAge = dateNow - dateDob;
      else {
        monthAge--;
        dateAge = 31 + dateNow - dateDob;

        if (monthAge < 0) {
          monthAge = 11;
          yearAge--;
        }
      }

      if (returnAsArray)
        return [{ year: yearAge, month: monthAge, day: dateAge }];
      else {
        let stringOut =
          yearAge != 0
            ? yearAge + i18n.t("general.year") + i18n.t("general.and")
            : "";
        monthAge ? (stringOut += monthAge) : "";
        monthAge && dateAge
          ? (stringOut += " " + i18n.t("general.month") + i18n.t("general.and"))
          : "";
        dateAge ? (stringOut += dateAge + " " + i18n.t("general.day")) : "";
        return stringOut;
      }
    },
    persianToday() {
      return moment.from(new Date()).locale("fa").format("YYYY/MM/DD");
    },
    nowTime() {
      return moment.from(new Date()).locale("fa").format("HH:mm");
    },
    gregToday() {
      return moment
        .from(new Date())
        .locale("en")
        .format("YYYY MM  DD, hh:mm:ss");
    },
    compareDate(date1, date2) {
      if (new Date(date1) > new Date(date2)) {
        return "G"; // greater than
      } else if (new Date(date1) > new Date(date2)) {
        return "L"; // less than
      } else return "E"; // equal
    },
    getDefaultDateItems(hasTime = true) {
      let startDate = new Date();
      let endDate = new Date();
      if (hasTime) {
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 0);
        return [startDate.toISOString(), endDate.toISOString()];
      }else{
        return [moment.from(startDate).format( "YYYY-MM-DD"), moment.from(endDate).format( "YYYY-MM-DD")]
      }


    },
    getDefaultTimeItems() {
      let startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      let endDate = new Date();
      endDate.setHours(23, 59, 59, 0);
      return [startDate.toISOString(), endDate.toISOString()];
    },
    getFormattingTime(timestamp) {
      let hours = Math.floor(timestamp / 60 / 60)
        .toString()
        .padStart(2, "0");
      let minutes = (Math.floor(timestamp / 60) - hours * 60)
        .toString()
        .padStart(2, "0");
      let seconds = (timestamp % 60).toString().padStart(2, "0");
      let formatted = hours + ":" + minutes + ":" + seconds;
      return formatted;
    },
  },
  computed: {},
};
